export default "__VITE_ASSET__CyubglHa__"